import React from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";

type PedidoOptionsProps = {
    configData?: {
        flg_limpa_campos_add_item?: boolean;
        flg_usa_grade_pedido?: boolean;
        flg_ordem_compra?: boolean;
        flg_prazo_pagto_tabela_externa?: boolean;
        quant_dias_pedido?: string;
    };
    setConfigData?: (data: Partial<PedidoOptionsProps["configData"]>) => void;
};

const PedidoOptions: React.FC<PedidoOptionsProps> = ({ configData, setConfigData }) => {
    // apresentando erro apra edição
    const handleToggle = (key: keyof PedidoOptionsProps["configData"]) => {
        if (configData && setConfigData) {
            setConfigData({
                ...configData,
                [key]: !configData[key],
            });
        }
    };

    return (
        <div className="card-body">
            <h5 className="mb-4">Opções do Pedido</h5>

            {/* Limpar Campos */}
            <div className="border-bottom mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <span>Limpar campos dos dados dos produtos no ato da inclusão no pedido?</span>
                    <button
                        type="button"
                        className={`btn btn-sm ${
                            configData?.flg_limpa_campos_add_item
                                ? "btn-outline-success d-flex gap-2"
                                : "btn-outline-danger d-flex gap-1"
                        }`}
                        onClick={() => handleToggle("flg_limpa_campos_add_item" as keyof PedidoOptionsProps["configData"])}
                    >
                        <FontAwesomeIcon
                            icon={configData?.flg_limpa_campos_add_item ? faToggleOn : faToggleOff}
                            size="lg"
                        />
                        {configData?.flg_limpa_campos_add_item ? "ON" : "OFF"}
                    </button>
                </div>
                <p className="text-muted small mb-3">
                    Deixando esta opção marcada, quando inclui-se um item no pedido, o sistema limpará os
                    campos e setará para o campo inicial. Se você não utiliza grade, é recomendado ativar.
                </p>
            </div>

            {/* Utilizar grades */}
            <div className="border-bottom mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <span>Utilizar de grades na venda de itens do pedido?</span>
                    <button
                        type="button"
                        className={`btn btn-sm ${
                            configData?.flg_usa_grade_pedido
                                ? "btn-outline-success d-flex gap-2"
                                : "btn-outline-danger d-flex gap-1"
                        }`}
                        onClick={() => handleToggle("flg_usa_grade_pedido" as keyof PedidoOptionsProps["configData"])}
                    >
                        <FontAwesomeIcon
                            icon={configData?.flg_usa_grade_pedido ? faToggleOn : faToggleOff}
                            size="lg"
                        />
                        {configData?.flg_usa_grade_pedido ? "ON" : "OFF"}
                    </button>
                </div>
                <p className="text-muted small mb-3">
                    Esta opção faz com que o sistema utilize uma tabela de grade de tamanhos para os
                    produtos. Desmarcando, também desmarcará opções de impressão relacionadas a grades.
                </p>
            </div>

            {/* Ordem de Compra */}
            <div className="border-bottom mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <span>Utilizar Nº de Ordem de Compra no Pedido?</span>
                    <button
                        type="button"
                        className={`btn btn-sm ${
                            configData?.flg_ordem_compra
                                ? "btn-outline-success d-flex gap-2"
                                : "btn-outline-danger d-flex gap-1"
                        }`}
                        onClick={() => handleToggle("flg_ordem_compra" as keyof PedidoOptionsProps["configData"])}
                    >
                        <FontAwesomeIcon
                            icon={configData?.flg_ordem_compra ? faToggleOn : faToggleOff}
                            size="lg"
                        />
                        {configData?.flg_ordem_compra ? "ON" : "OFF"}
                    </button>
                </div>
                <p className="text-muted small mb-3">
                    Esta opção permite informar o número de ordem de compra no pedido.
                </p>
            </div>

            {/* Prazo Pagamento */}
            <div className="border-bottom mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <span>Usar prazos de pagamento de uma tabela externa?</span>
                    <button
                        type="button"
                        className={`btn btn-sm ${
                            configData?.flg_prazo_pagto_tabela_externa
                                ? "btn-outline-success d-flex gap-2"
                                : "btn-outline-danger d-flex gap-1"
                        }`}
                        onClick={() => handleToggle("flg_prazo_pagto_tabela_externa" as keyof PedidoOptionsProps["configData"])}
                    >
                        <FontAwesomeIcon
                            icon={configData?.flg_prazo_pagto_tabela_externa ? faToggleOn : faToggleOff}
                            size="lg"
                        />
                        {configData?.flg_prazo_pagto_tabela_externa ? "ON" : "OFF"}
                    </button>
                </div>
                <p className="text-muted small mb-3">
                    Esta opção permite utilizar uma tabela externa para exibir os prazos cadastrados.
                </p>
            </div>

            {/* Quantidade de Dias */}
            <Form.Group className="row">
                <div className="d-flex align-items-center justify-content-between">
                    <Form.Label>Dias para Data de Entrega</Form.Label>
                    <div className="col-2">
                        <Form.Control
                            type="number"
                            value={configData?.quant_dias_pedido || ""}
                            onChange={(e) =>
                                setConfigData?.({ ...configData, quant_dias_pedido: e.target.value })
                            }
                            placeholder="Digite a quantidade de dias"
                        />
                    </div>
                </div>
                <p className="text-muted small">
                    Quantidade de dias que serão somados para gerar a data de entrega, a partir da
                    data de criação.
                </p>
            </Form.Group>
        </div>
    );
};

export default PedidoOptions;
